import type { ReactNode } from 'react';
import './PhoneFrame.css';

export type PhoneFrameSize = 'sm' | 'md' | 'lg';

export interface PhoneFrameProps {
  children: ReactNode;
  size?: PhoneFrameSize;
  float?: boolean;
  glow?: boolean;
  label?: string;
}

export function PhoneFrame({
  children,
  size = 'md',
  float = false,
  glow = false,
  label,
}: PhoneFrameProps) {
  const className = [
    'motion-phone',
    `motion-phone--${size}`,
    float ? 'motion-phone--float' : '',
    glow ? 'motion-phone--glow' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className='motion-phone-wrap'>
      <div className={className}>
        <div className='motion-phone__bezel'>
          <div className='motion-phone__island' aria-hidden='true' />
          <div className='motion-phone__screen'>{children}</div>
        </div>
      </div>
      {label ? <span className='motion-phone__label'>{label}</span> : null}
    </div>
  );
}
